import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "@theme/";

const globalStyles = css`
  .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid #eb7909 !important;
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(227, 110, 0, 0.2) !important;
    border-radius: 0.75rem !important;
    transition: all 0.3s ease !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-focused .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
    border-color: ${theme.colors.modernPrimary} !important;
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1) !important;
  }

  .ant-select-selection-item {
    line-height: 44px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-placeholder {
    color: #9ca3af !important;
    font-weight: 400 !important;
  }

  .ant-select-arrow {
    color: #E36E00 !important;
    transition: all 0.3s ease !important;
  }

  .ant-select:hover .ant-select-arrow {
    color: #FFAE00 !important;
    transform: scale(1.1) !important;
  }

  .ant-select-clear {
    color: #E36E00 !important;
    background: rgba(227, 110, 0, 0.1) !important;
    border-radius: 50% !important;
    transition: all 0.3s ease !important;
  }

  .ant-select-clear:hover {
    color: #FFAE00 !important;
    background: rgba(227, 110, 0, 0.2) !important;
    transform: scale(1.1) !important;
  }

  .ant-select-dropdown {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(227, 110, 0, 0.2) !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
    padding: 8px 0 !important;
  }

  .ant-select-item {
    padding: 8px 16px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #374151 !important;
    transition: all 0.3s ease !important;
    border-radius: 8px !important;
    margin: 2px 8px !important;
  }

  .ant-select-item:hover {
    background: rgba(227, 110, 0, 0.1) !important;
    color: #E36E00 !important;
    transform: translateX(4px) !important;
  }

  .ant-select-item-option-selected {
    background: rgba(227, 110, 0, 0.15) !important;
    color: #E36E00 !important;
    font-weight: 600 !important;
  }

  .ant-select-item-option-active {
    background: rgba(227, 110, 0, 0.1) !important;
    color: #E36E00 !important;
  }
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
};

export default SC;
